// src/components/PhoneNumberInput.js (o donde lo quieras ubicar)
import React from 'react';

const PhoneNumberInput = ({ value, onChange }) => {
	const handleChange = (event) => {
		const inputValue = event.target.value;
		const sanitizedValue = inputValue.replace(/[^0-9+]/g, '');

		let finalValue = sanitizedValue;
		if (finalValue.includes('+')) {
			if (finalValue.indexOf('+') !== 0) {
				finalValue = '+' + finalValue.replace(/\+/g, '');
			}
			finalValue = finalValue.replace(/\++/g, '+');
		}

		onChange(finalValue);
	};

	return (
		<input
			type="text"
			value={value}
			onChange={handleChange}
			placeholder="+595981123456"
			inputMode="tel" // Sugiere teclado numérico en móviles
			aria-label="Número de teléfono"
		/>
	);
};

export default PhoneNumberInput;
